<script>
import ShowCpt from "./components/ShowCpt.vue";
export default {
  name: "App",
  components: {
    ShowCpt,
  },
};
</script>

<template>
  <ShowCpt />
</template>

<style lang="scss">
// N'utiliser ce CSS que en cas de l'usage NPM RUN DEV
/*
#block-app {
  width: 100%;
  #app {
    @media (max-width: 780px) {
      padding: 0rem;
    }
  }

  .filter-input {
    &::placeholder {
      font-family: "Bree-Regular";
      color: #872d2c;
      font-size: 18px;
      padding-top: 0.5rem;
    }
  }

  .results {
    display: flex;
    justify-content: center;
    flex-wrap: wrap;

    .cpt-extrait {
      margin-right: 1.5rem;
      margin-bottom: 1.5rem;
      width: 15%;
      -webkit-box-shadow: 0px 6px 23px 8px rgb(154 154 154 / 27%);
      box-shadow: 0px 6px 23px 8px rgb(154 154 154 / 27%);
      position: relative;
      padding-bottom: 6rem;

      h3 {
        font-size: 26px;
        width: 100%;
        display: flex;
        justify-content: center;
        padding: 2rem;
        color: #872d2c;
        z-index: 1;
        position: relative;
        a {
          color: #872d2c;
          text-align: center;
        }
      }

      .desc-page {
        padding: 0rem 2rem 2rem 2rem;
      }

      .terms-container {
        position: absolute;
        top: 0;
        right: 0;
        padding-top: 1rem;
        height: 100%;
        width: 100%;

        .nouvelle_recette {
          background: white;
          padding: 0.2rem 1rem;
          margin-bottom: 0.5rem;
          font-family: "Cafeteria-Regular" !important;
          font-size: 20px;
        }

        .term-libre {
          background: white;
          padding: 0.2rem 1rem;
          margin-bottom: 0.5rem;
          right: 0;
          position: absolute;
          font-family: "Cafeteria-Regular" !important;
          font-size: 20px;
        }

        .term-wrapper {
          position: relative;
          display: flex;
          justify-content: flex-end;
          padding-bottom: 0.6rem;

          .term {
            color: white;
            font-family: "Bree-Regular" !important;
            font-size: 19px;
            padding-left: 15px;
            padding-right: 15px;
          }

          .term-bg {
            width: 8rem;
          }
        }

        .term-wrapper {
          &.beurre {
            .term {
              background-color: #872d2c;
            }
          }
          &.cremerie {
            .term {
              background-color: #872d2c;
            }
          }
          &.epicerie {
            .term {
              background-color: #ae6b6b;
            }
          }
          &.fromages {
            .term {
              background-color: #ae6b6b;
            }
          }
          &.specificite {
            .term {
              background-color: #ae6b6b;
            }
          }
          &.type_de_recette {
            .term {
              background-color: #872d2c;
            }
          }
        }
      }

      .img-container {
        height: 230px;

        img {
          width: 100%;
          height: 100%;
          object-fit: cover;
        }
      }

      .buttons-extrait {
        padding-bottom: 1rem;
        position: absolute;
        bottom: 1rem;
        width: 100%;
        white-space: nowrap;
        z-index: 1;
        .cta_center {
          display: flex;
          justify-content: center;
        }

        a {
          display: flex;
          justify-content: center;
          align-items: center;
          position: relative;

          span {
            z-index: 1;
            position: absolute;
            font-family: "Bree-Regular" !important;
            color: white;
            font-size: 22px;
            text-transform: uppercase;
            color: #ae6b6b;
            border: 1px solid #ae6b6b;
            padding-left: 10px;
            padding-right: 10px;
          }
        }
      }

      @media (max-width: 1280px) {
        width: 47%;
      }

      @media (max-width: 780px) {
        margin-right: 0;
        width: 100%;
      }
    }
  }

  .filters {
    display: flex;
    flex-direction: column;

    .text-filter-container {
      position: relative;
      margin-bottom: 1rem;

      .svg-loop-searchbox {
        height: 1.5rem;
        position: absolute;
        top: 33%;
        left: 2%;
      }
    }

    @media (max-width: 780px) {
      .svg-searchbox {
        width: 100% !important;
      }
    }
  }

  .filter-input {
    width: 50%;
    padding: 0.5rem 1rem 0.5rem 4rem;
    border-radius: 1.5rem !important;
    margin-top: 1rem;
    margin-bottom: 1rem;
    color: black;
  }

  .filters {
    display: flex;
    flex-direction: column;

    .buttons {
      display: flex;
      flex-direction: row;
      flex-wrap: wrap;
      &:nth-child(odd) {
        .button {
          background: white;
          color: #872d2c;
          border: 2px solid #872d2c;
          &.active {
            background: #872d2c;
            color: white;
          }
        }
      }
      &:nth-child(even) {
        .button {
          background: white;
          color: #ae6b6b;
          border: 2px solid #ae6b6b;

          &.active {
            background: #ae6b6b;
            color: white;
          }
        }
      }
      .button {
        margin-bottom: 1rem;
        margin-right: 1rem;
        cursor: pointer;
        display: flex;
        padding: 0.3rem 1.5rem;
        border-radius: 1.5rem;
        white-space: nowrap;
        border: 2px solid black;
        font-family: "Bree-Regular";
      }

      .active {
        background-color: black;
        color: white;
      }
    }
  }

  .load-more-container {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 1rem;
    margin-bottom: 1rem;

    .load-more {
      color: rgb(0, 0, 0);
      font-family: "Bree-Regular" !important;
      font-size: 20px;
      position: absolute;
      cursor: pointer;
      text-transform: uppercase;
    }

    svg {
      cursor: pointer;
    }
  }
} */
</style>
